<template>
  <div class="slide-menu">
    <div class="active-menu-item-cover" :style="{top: `${coverTop}px`}">
      <div class="active-slide-menu" :style="{transform: `translateY(${activeTranslateY}px)`}">
        <slot></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    activeIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      hasMounted: false,
      coverTop: 0,
      activeTranslateY: 0
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.hasMounted = true
    this.refreshActiveCover()
  },
  methods: {
    refreshActiveCover () {
      if (!this.hasMounted) {
        return
      }
      const menuItemElList = _.slice(this.$el?.children, 1)
      if (!menuItemElList || menuItemElList.length < 0) {
        return
      }
      const activeMenuItemEl = menuItemElList[this.activeIndex]
      const menuRect = this.$el.getBoundingClientRect()
      const activeMenuItemRect = activeMenuItemEl.getBoundingClientRect()
      const coverTop = activeMenuItemRect.top - menuRect.top
      this.coverTop = coverTop
      setTimeout(() => {
        this.activeTranslateY = -coverTop
      })
    }
  },
  watch: {
    activeIndex: {
      immediate: true,
      handler () {
        this.refreshActiveCover()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-menu {
  position: relative;

  .active-menu-item-cover {
    width: 100%;
    overflow: hidden;
    transition: top .3s;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    .active-slide-menu {
      transform: translateY(0);
      transition: transform .3s;
    }
  }
}
</style>
